import { render, staticRenderFns } from "./MsGoodsList.vue?vue&type=template&id=3a39f8e8&scoped=true&"
import script from "./MsGoodsList.vue?vue&type=script&lang=js&"
export * from "./MsGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39f8e8",
  null
  
)

export default component.exports